import * as actions from 'actions/productBuyBackActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';
export const defaultState = {
    asyncStatus: AsyncStatus.INIT
};
export default createReducer(actions.ABB_SHOW_MORE_REQUEST, actions.ABB_SHOW_MORE_SUCCESS, actions.ABB_SHOW_MORE_ERROR, defaultState);
